import script from "./AdminReleases.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminReleases.vue?vue&type=script&setup=true&lang=js"

import "./AdminReleases.vue?vue&type=style&index=0&id=736b7890&lang=css"

const __exports__ = script;

export default __exports__